import { FC, HTMLAttributes, useState } from "react"

import { FieldError } from '../../../../../widgets'
import { IPasswordProps } from "./IPasswordProps"
import clsx from 'clsx'
import { usePasswordValidationSchema } from './PasswordValidationSchema'

interface IPasswordFieldProps extends HTMLAttributes<HTMLInputElement>, IPasswordProps {
}

export const SimplePassword: FC<IPasswordFieldProps> = (props) => {
    const { id, value: initValue, placeholder, className, readOnly, disabled } = props
    const schema = usePasswordValidationSchema(props)
    const [error, setError] = useState<string>();
    const [value, setValue] = useState<string>(initValue || '');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        setValue(inputValue)

        schema?.validate(inputValue)
            .then(() => setError(undefined))
            .catch((error) => setError(error.message))
    }

    return <>
        <input
            type='password'
            id={id}
            className={clsx(className, "form-control form-control-sm")}
            placeholder={placeholder}
            readOnly={readOnly}
            disabled={disabled}
            value={value}
            onChange={handleChange}
        />
        {error && <FieldError show={true} message={error} />}
    </>
}
